import { useEffect } from 'react'

/**
 * Publish the height of the on-screen keyboard as `--keyboard-inset`.
 *
 * Android resizes the layout viewport, so CSS alone copes. iOS does not: the
 * page keeps its full height and the keyboard is drawn over it, which puts the
 * chat input underneath the thing you are typing on. `visualViewport` is the
 * only way to find out how much is covered.
 */
export const useKeyboardInset = (): void => {
  useEffect(() => {
    const viewport = window.visualViewport
    if (viewport === undefined || viewport === null) return

    const update = (): void => {
      // How much of the layout viewport the visual viewport no longer covers.
      const covered = window.innerHeight - viewport.height - viewport.offsetTop
      document.documentElement.style.setProperty(
        '--keyboard-inset',
        `${Math.max(0, Math.round(covered))}px`,
      )
    }

    update()
    viewport.addEventListener('resize', update)
    viewport.addEventListener('scroll', update)
    return () => {
      viewport.removeEventListener('resize', update)
      viewport.removeEventListener('scroll', update)
      document.documentElement.style.removeProperty('--keyboard-inset')
    }
  }, [])
}
